import Get from '../services/Get';
import Put from '../services/Put';

import { nexcareVersion } from '../config/serviceConfig';

const getServerTime = (token) => Get(`/${nexcareVersion}/nexcare/time`, token);
const getInitiateNotification = (token) => Get(`/${nexcareVersion}/nexcare/notification/initiate`, token);
const getListNotification = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/notification?page=${page}&limit=${limit}&order=date(created_at) desc`, token);
const putReadNotification = (data, id, token) => Put(`/${nexcareVersion}/nexcare/notification/read/${id}`, data, token);

const API_NOTIFICATION = {
    getServerTime,
    getInitiateNotification,
    getListNotification,
    putReadNotification
}

export default API_NOTIFICATION;